import {positionTopRight} from '../../../shared-components/mixin/position';
import {Btn} from '../button/btn-type/Btn';

export const badgeColorSetup = ({background, txt, border}) => `
    background: ${background || 'var(--disabled)'};
    outline: 1px solid ${border || 'var(--disabled)'};
    color: ${txt || 'var(--white-00)'};
    border: none;
`;

export const badgeColor = (color, ghost, text, outline) => {
    if (outline) {
        if (color) {
            return `
            ${badgeColorSetup({
                border: `var(--${color})`,
                txt: `var(--${color})`,
            })};
            background: none;
        `;
        } else {
            return `
            ${badgeColorSetup({
                txt: `var(--label-text-color)`,
            })};
            background: none;
        `;
        }
    }
    if (text) {
        if (color) {
            return `
            ${badgeColorSetup({
                txt: `var(--${color})`,
            })};
            outline: none;
            background: none;
        `;
        } else {
            return `
            ${badgeColorSetup({
                txt: `var(--label-text-color)`,
            })};
            background: none;
        `;
        }
    } else if (ghost) {
        if (color) {
            return `
            ${badgeColorSetup({
                border: `var(--${color}-ghost)`,
                txt: `var(--${color})`,
                background: `var(--${color}-ghost)`,
            })};
        `;
        } else {
            return `
            ${badgeColorSetup({
                txt: `white`,
                background: `gray`,
            })};
        `;
        }
    } else {
        if (color) {
            return `
            ${badgeColorSetup({
                background: `var(--${color})`,
                border: `var(--${color})`,
            })};
        `;
        } else {
            return `
            ${badgeColorSetup};
        `;
        }
    }
};

export const badgeRemovableCondition = (remove) => {
    if (remove) {
        return `
            margin-right: var(--space-md);
            ${Btn} {
                ${positionTopRight()}
                transform: translate(8px, -8px);
            }
        `;
    } else {
        return `
        `;
    }
};
